import { render } from "./Main.vue?vue&type=template&id=2e40a58d&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=2e40a58d&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\osago\\landing-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e40a58d"]])

export default __exports__